import { PartitionLoopSwapICountJCount } from "./PartitionLoopSwapICountJCount";
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from "../../enums/QuickSortStep";
import { IQuickSortContext } from "../../IQuickSortContext";

export class PartitionLoopIncrementICountState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionLoopIncrementICount;

  Description = "Increment i value";

  private _savedState : { ICount : number | undefined } | undefined;

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void { 
    if (this._context && this._context.ICount !== undefined) {
      
      if (this._savedState === undefined) {
        this._savedState = {
          ICount: this._context.ICount
        }
      }
      else {
        this._savedState.ICount = this._context.ICount;
      }

      this._context.ICount++;
    }
  }

  Undo(): void {
    if (this._savedState && this._context) {
      this._context.ICount = this._savedState.ICount;
    }
  }

  Exit(): void {
    if (this._context !== undefined) {
      this._context.TransitionTo(new PartitionLoopSwapICountJCount());
    }
  }
}